module.exports = __webpack_public_path__ + "img/no-img.b2633dd7.png";